import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import * as _ from 'lodash'
import { Slider, Tooltip } from 'wix-style-react'
import { ChromePicker } from 'react-color'
import { BLUE } from 'components/styles'
import Text from 'components/common/Text'

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 80px;
  margin-top: 10px;
`
const NameContainer = styled.div`
  display: flex;
  width: 150px;
  height: 30px;
  align-items: center;
  justify-content: space-between;
  & > span {
    line-height: 120%;
  }
`
const ResetTextContainer = styled.div`
  margin-left: 30px;
  cursor: pointer;
`
const SliderContainer = styled.div`
  width: 260px;
  position: relative;
  top: -0.35em;
`
const ColorPickerButton = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 4px;
  background-color: ${props => props.color};
  border: solid 2px ${BLUE};
  margin-right: 10px;
  cursor: pointer;
`

const defaultColor = {
  r: 255,
  g: 255,
  b: 255,
  a: 1
}

class SPAround extends Component {

  constructor (props) {
    super(props)
    this.state = {
      value: (props.currentValue.value) ? props.currentValue.value : 100,
      color: (props.currentValue.color) ? props.currentValue.color : defaultColor,
    }
    this.debouncedOnChange = _.throttle(props.onChange, 300)
  }

  onChange = (data) => {
    // console.log('onChange', data)
    const v = data[0]
    if (v !== this.state.value) {
      this.setState({
        value: v
      })
      this.debouncedOnChange({value: v, color: this.state.color})
    }
  }

  onChangeColor = (v) => {
    // console.log('onChangeColor', v)
    this.setState({
      color: v.rgb
    })
    this.debouncedOnChange({value: this.state.value, color: v.rgb})
  }

  onReset = () => {
    this.props.onChange({})
    this.setState({
      value: 100,
      color: defaultColor
    })
  }

  renderColorPicker () {
    return (
      <ChromePicker
        color={this.state.color}
        onChangeComplete={this.onChangeColor}
      />
    )
  }

  render () {
    const { title, isBgChange } = this.props
    const { color } = this.state
    const sColor = `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`
    return (
      <Container>
        <NameContainer>
          <Text size='medium'>{title}</Text>
        </NameContainer>

        <Tooltip
          content={this.renderColorPicker()}
          hideTrigger='click'
          onClickOutside={null}
          onShow={null}
          placement='bottom'
          shouldCloseOnClickOutside
          showTrigger='click'
        >
          <ColorPickerButton color={sColor} />
        </Tooltip>

        {!isBgChange && <SliderContainer>
          <Slider
            min={20}
            max={200}
            step={5}
            value={[this.state.value]}
            onChange={this.onChange}
          />
        </SliderContainer>}

        <ResetTextContainer
          onClick={this.onReset}
        >
          <Text size='medium'>RESET</Text>
        </ResetTextContainer>
      </Container>
    )
  }
}

SPAround.defaultProps = {
  currentValue: {},
  onChange: () => null,
  title: '',
  isBgChange: false
}

SPAround.propTypes = {
  currentValue: PropTypes.object,
  onChange: PropTypes.func,
  title: PropTypes.string,
  isBgChange: PropTypes.bool
}

export default SPAround



// WEBPACK FOOTER //
// ./src/components/editor/popovers/customCSS/stylePresetComponents/SPAround.js